import ProvideTransferDetailsView from './ProvideTransferDetailsView';

export default ProvideTransferDetailsView;
